<template>
  <div class="box d-flex flex-column justify-center">
    {{ title }}
  </div>
</template>
<script>
export default {
  name: "QuestionBox",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped lang="scss">
@import "node_modules/shared-components/assets/style/color.scss";
.box {
  background-color: $c_davys_grey;
  height: 50px;
  width: 100%;
  padding-left: 10px;
  border-radius: 5px;
}
</style>
